import axios, { InternalAxiosRequestConfig } from 'axios';

const setUpPreventCacheInterceptor = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  axios.interceptors.request.use((config: InternalAxiosRequestConfig<any>) => {
    const isApiUrl = config.url?.includes('/api/');
    if (isApiUrl && config.method === 'get') {
      config.params = { ...config.params, preventCache: new Date().getTime() };
    }
    return config;
  });
};

export default setUpPreventCacheInterceptor;
